export default "__VITE_ASSET__de756f0d__"